// extracted by mini-css-extract-plugin
export default {"appHeader":"AppHeader_appHeader__TluGl"};